import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import CategoryTabs from '@/components/base/CategoryTabs';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredComics = slug
    ? comics.filter((c) => c.category === slug)
    : comics;

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
            </div>
            <h2 className="font-heading text-xl text-foreground-900 mb-2">
              分类未找到
            </h2>
            <Link
              to="/"
              className="text-primary-500 hover:text-primary-600 text-sm"
            >
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-14 md:pb-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
              <i className={`${category.icon} text-lg text-primary-600`}></i>
            </div>
            <div>
              <h1 className="font-heading text-2xl md:text-3xl text-foreground-900">
                {category.name}韩漫
              </h1>
              <p className="text-sm text-foreground-500 mt-1">
                共 {filteredComics.length} 部作品
              </p>
            </div>
          </div>

          <div className="mb-8">
            <CategoryTabs />
          </div>

          {filteredComics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {filteredComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-book-open-line text-4xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-500">该分类暂无漫画</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}